export default "__VITE_ASSET__DyLddgMY__"